/**
 * location 领域的 GameState 分片注册（队伍与位置）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { PartyStateSchema, type PartyState } from './types/party';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    party?: PartyState;
  }
}

registerGameStateSlice('party', PartyStateSchema.optional(), () => ({
  members: [],
  formation: [],
  location: {
    world: { x: -20.59, y: 23.25 }, // 初始世界坐标
    zone: {
      id: '208',
      name: '庞德敦',
      localX: 50,
      localY: 50,
    },
  },
  visitedLocations: [],
}));
